import React, { Component } from 'react';
import { Row } from 'antd';
import QueueAnim from 'rc-queue-anim';
import axios from "axios"
import Texty from 'rc-texty';

const baseURL = process.env.REACT_APP_API_URL;

class Foot extends Component {
    constructor(props) {
        super(props);
        this.state = {
            info: [],
            categorys: props.categorys || [],
        };
    }
    componentDidMount() {
        // axios.get(`http://www.as-gold.net/api/data.php?t=info`).then(res => {
        //     const info = res.data;
        //     this.setState({ info: info });
        // })
         axios.post(baseURL + 'docs/list',{}).then(res => {
            const info = res.data.list;
            this.setState({ info: info });
        })
    }

    render() {
        var slg = "";
        var desc = "";

        this.state.info.forEach(element => {
            if (element.keyword === "slg") {
                slg = element.title;
            }
            if (element.keyword === "desc") {
                desc = element.title;
            }
        });
        return (
            <QueueAnim type="bottom" duration={2000} interval={500}>
                <h1><Texty>About Us</Texty></h1>
                <h3 key="slg">{slg}</h3>
                <Row key="desc" style={{ marginTop: 16 }}>
                    <div
                        className="content"
                        dangerouslySetInnerHTML={{ __html: desc }}
                    />
                </Row>
            </QueueAnim>
        );
    }
}

export default Foot;
